<app-breadcrumbs [title]="'MENU.ADMINISTRATION.EXCEPTION_LOGS'" [first]="'MENU.ADMINISTRATION.EXCEPTION_LOGS'"></app-breadcrumbs>

<div class="row">
    <dx-data-grid #table [dataSource]="dataSource" 
                        [rowAlternationEnabled]="true" 
                        [showBorders]="true" 
                        [showRowLines]="false" 
                        [showColumnLines]="true"                 
                        [allowColumnResizing]="true"
                        [allowColumnReordering]="true"
                        columnResizingMode="nextColumn"
                        [hoverStateEnabled]="true"
                        [allowColumnResizing]="true"
                        [allowColumnReordering]="true"
                        columnResizingMode="nextColumn">
        <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true"></dxo-remote-operations>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-pager [showInfo]="true"></dxo-pager>
        <dxo-state-storing [enabled]="true" [type]="'custom'" [customLoad]="loadGridState" [customSave]="saveGridState"></dxo-state-storing>
    
        <dxi-column dataField="dateCreated" [width]="150" dataType="date" [format]="{ type: 'dd.MM.yyyy. HH:mm' }" sortOrder="desc" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.DATE_MODIFIED' | translate"></dxi-column>
        <dxi-column dataField="className" [width]="110" dataType="string" [allowFiltering]="true" [allowSorting]="true" [width]="160" [caption]="'EXCEPTION-LOGS.CLASS-NAME' | translate"></dxi-column>
        <dxi-column dataField="url" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'EXCEPTION-LOGS.URL' | translate"></dxi-column>
        <dxi-column dataField="type" [width]="80" cellTemplate="typeTemplate" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'EXCEPTION-LOGS.TYPE' | translate">
            <dxo-lookup [dataSource]="types" valueExpr="value" displayExpr="label"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="userId" [width]="150" dataType="string" [allowFiltering]="true" [filterOperations]= "['=']" [allowSorting]="true" [caption]="'EXCEPTION-LOGS.USER-CREATED' | translate"></dxi-column>
        <dxi-column dataField="companyId" [width]="150" dataType="string" [allowFiltering]="true" [filterOperations]= "['=']" [allowSorting]="true" [caption]="'COMPANIES.COMPANY' | translate"></dxi-column>
        
    
        <div *dxTemplate="let template of 'typeTemplate'">
            <span class="table-label status-{{template.data.type}}">{{ 'ENUMS.EXCEPTION-LOGS.' + template.data.type | translate }}</span>
        </div>
    
        <dxi-column cellTemplate="actionsTemplate" [fixed]="true" fixedPosition="right"[allowFiltering]="false" [allowSorting]="false" [width]="95" [caption]="''" [cssClass]="'actions'"></dxi-column>
        <div *dxTemplate="let template of 'actionsTemplate'">
            <span class="table-icon ti-eye" [matTooltip]="'SHARED.VIEW' | translate" matTooltipPosition="above" matTooltipHideDelay="200" [routerLink]="['./', template.data.id]"></span>
            <span class="table-icon dx-icon-trash" [matTooltip]="'SHARED.DELETE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="delete(template.data.id)"></span>
        </div>
       
    </dx-data-grid>
</div>
